import { api } from '@shared/api/api';

type VenueData = App.Domain.Event.Data.VenueData;

export const getVenue = api.createShow<VenueData>('venues/:id');
